import { WalletIndicatorTranslations } from "./wallet-indicator-pt-br";

export const WALLET_INDICATOR_ES_MX: WalletIndicatorTranslations = {
	anticipation: "Disponible para anticipación",
	anticipationSmDevice: "Disponible para anticipación",
	anticipationTooltip:
		"Valores de transacciones de tarjeta de crédito que aún no han sido liquidadas.",
	seeWallet: "Ver Billetera",
	totalBalance: "Saldo total",
	wallet: "Billetera",
	withdrawal: "Disponible para retiro",
	yourAccounts: "Tus cuentas",
	blockedBalance: "Valor Bloqueado",
	blockedBalanceTooltip:
		"Valores retenidos por Zig por motivos operacionales, entradas futuras, transferencias al Vendor y otros bloqueos.",
	blockedByPendingWithdraws: "Retiros en procesamiento",
	blockedByPendingWithdrawsTooltip:
		"El valor total corresponde a las solicitudes de retiro en procesamiento por Zig",
};
